// Three icons, 16px, drawn on the same 16-unit grid so the optical weight
// matches across the group — a sun with eight rays next to a solid crescent
// reads as two different sizes even when the boxes are identical.
//
// Stroke and fill come from `currentColor` via .theme-icon in theme.css, so the
// icons inherit the button's state colour and no colour is declared here.
// tokens.css is the only place colour lives.

function Icon({ children }) {
  return (
    <svg
      className="theme-icon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      focusable="false"
    >
      {children}
    </svg>
  )
}

/** Light. */
export function SunIcon() {
  return (
    <Icon>
      <circle cx="8" cy="8" r="3.1" />
      <path d="M8 1.1v1.6M8 13.3v1.6M14.9 8h-1.6M2.7 8H1.1M12.88 3.12l-1.13 1.13M4.25 11.75l-1.13 1.13M12.88 12.88l-1.13-1.13M4.25 4.25L3.12 3.12" />
    </Icon>
  )
}

/** Dark. A crescent, not a moon with craters: at 16px the craters are noise. */
export function MoonIcon() {
  return (
    <Icon>
      <path d="M13.6 9.7A6 6 0 0 1 6.3 2.4a5.9 5.9 0 1 0 7.3 7.3Z" />
    </Icon>
  )
}

/** System — a monitor, because the choice is "whatever this machine says". */
export function MonitorIcon() {
  return (
    <Icon>
      <rect x="1.4" y="2.6" width="13.2" height="8.6" rx="1.3" />
      <path d="M5.6 14h4.8M8 11.2V14" />
    </Icon>
  )
}
